export const LIKES_AMOUNT_TO_SHOW_POPUP = 10
